// extracted by mini-css-extract-plugin
export default {"wrapper":"B1-z","play":"C1-z"};